import React from 'react';
import { useTranslation } from 'react-i18next';

import useClasses from '../../hooks/useClasses';

import './style.scss';

const Loader: React.FC = () => {
  const { t } = useTranslation();
  const { buildClass } = useClasses('Loader');

  return (
    <div className={buildClass()}>
      {t('titles.loading')}
    </div>
  );
};

export default Loader;
